// extracted by mini-css-extract-plugin
module.exports = {"container":"UserLoadingMessage_container__5f5PV","bubble":"UserLoadingMessage_bubble__JgZEf","loader":"UserLoadingMessage_loader__Vi9Ln"};